import { render, staticRenderFns } from "./ProveedorCrud.vue?vue&type=template&id=f24638a6&"
import script from "./ProveedorCrud.vue?vue&type=script&lang=js&"
export * from "./ProveedorCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports